import { useEffect, useState } from 'react';
import { ActionBar, EditPrintTemplateDialog, InitialSearchDialog } from './components';
import { useActionHandlers, useDialogState, useTableData } from './hooks';
import { useSoChiTietCongNoNhieuKhachHang } from '@/hooks';
import { ErpDataTableV2 } from '@/components/custom/erp';
import { SearchFormValues } from './schema';

export default function SoChiTietCongNoNhieuKhachHangPage() {
  const {
    initialSearchDialogOpen,
    editPrintTemplateDialogOpen,
    showTable,
    handleInitialSearchClose,
    handleInitialSearch,
    handleSearchClick,
    handleEditPrintTemplateClick,
    handleClosePrintTemplateDialog,
    handleSavePrintTemplate
  } = useDialogState();

  const [searchParams, setSearchParams] = useState<SearchFormValues>({});
  const [pendingSearch, setPendingSearch] = useState(false);
  const { data, isLoading, fetchData, refreshData } = useSoChiTietCongNoNhieuKhachHang(searchParams);
  const { tables, handleRowClick } = useTableData(data);
  const { handleRefreshClick, handleFixedColumnsClick, handleExportDataClick } = useActionHandlers();

  // Auto show table when data is loaded after search
  useEffect(() => {
    if (pendingSearch && data.length > 0 && !showTable) {
      handleInitialSearch({});
      setPendingSearch(false);
    }
  }, [data.length, pendingSearch, showTable, handleInitialSearch]);

  const handleSearchWithData = async (values: SearchFormValues) => {
    setSearchParams(values);
    setPendingSearch(true);

    try {
      await fetchData(values);
      handleInitialSearchClose();
    } catch (error) {
      console.error('Error fetching data:', error);
      setPendingSearch(false);
      handleInitialSearchClose();
    }
  };

  const handleRefreshWithData = async () => {
    await refreshData();
    handleRefreshClick();
  };

  return (
    <div className='flex h-screen w-full flex-col overflow-hidden'>
      <InitialSearchDialog
        open={initialSearchDialogOpen}
        onClose={handleInitialSearchClose}
        onSearch={handleSearchWithData}
      />

      <EditPrintTemplateDialog
        open={editPrintTemplateDialogOpen}
        onClose={handleClosePrintTemplateDialog}
        onSave={handleSavePrintTemplate}
      />

      {showTable && (
        <>
          <ActionBar
            onSearchClick={handleSearchClick}
            onRefreshClick={handleRefreshWithData}
            onFixedColumnsClick={handleFixedColumnsClick}
            onExportDataClick={handleExportDataClick}
            onEditPrintTemplateClick={handleEditPrintTemplateClick}
            searchParams={searchParams}
            className='border-b border-gray-200'
          />

          <div className='flex-1 overflow-hidden'>
            {!isLoading && <ErpDataTableV2 tables={tables} onRowClick={handleRowClick} />}
          </div>
        </>
      )}
    </div>
  );
}
